<template>
	<div class="container bg_f9">
		<div class="head_part flex-box w1440">
			<router-link to="/"><img class="login_logo point ml10 mr30" src="../../assets/static/images/jj_logo_new.png"
					alt="" /></router-link>
			<div class="line mr30"></div>
			<div class="fs24 col-36 fw-600 flex-grow-1">找回密码</div>
			<router-link class="col04 fs14 blue fwb lh28 point" to="/Login">
				<div class="fs14 blue fwb lh28 mr5">返回登录</div>
			</router-link>
			<img class="login_right" src="../../assets/static/icon/jxr_login_right.png" alt="" />
		</div>
		<div class="main flex-box w1440">
			<div class="part1">
				<div class="fs14 col3 lh28 mb10">手机号码：</div>
				<div class="pr">
					<div :class="isPhone ? 'prompt_border1' : ''">
						<div class="part2">
							<input class="input" type="text" name="account" placeholder="请输入手机号码"
								v-model="formData.mobile" />
						</div>
					</div>
					<div class="fs18 red lh28 prompt_info" v-if="isPhone">手机号码格式有误</div>
				</div>
				<div class="fs14 col3 lh28 mb10">验证码：</div>
				<div class="pr">
					<div class="flex-box">
						<div :class="isCode ? 'prompt_border1' : ''" class="flex-grow-1">
							<div class="part2 part33 flex-grow-1">
								<input class="input" id="" type="text" name="" placeholder="请输入验证码"
									v-model="formData.code" />
							</div>
						</div>
						<!-- <div class="code_btn_on ml15  tc fs14 mb30 point">获取验证码</div> -->
						<button :class="captcha == '获取验证码' ? 'code_btn_on' : 'code_btn'" class="ml15 tc fs14 mb20 point"
							@click="handleCaptcha">
							{{ captcha }}
						</button>
					</div>
					<div class="fs18 red lh28 prompt_info" v-if="isCode">验证码错误</div>
				</div>
				<div class="fs14 col3 lh28 mb10">登录密码：</div>
				<div class="pr">
					<div :class="isPassword ? 'prompt_border1' : ''">
						<div class="part2 flex-box">
							<input class="input" id="password" :type="showPwd ? 'text' : 'password'" name="password"
								placeholder="请输入登录密码（6-20位数字与字母组合）" v-model="formData.password" />
							<img @click="showPwd = !showPwd" v-if="showPwd" class="img2 point"
								src="../../assets/static/icon/jxr_login_show.png" alt="" id="eye" />
							<img @click="showPwd = !showPwd" v-else class="img2 point"
								src="../../assets/static/icon/jxr_login_hide.png" alt="" id="eye" />
						</div>
					</div>
					<div class="fs18 red lh28 prompt_info" v-if="isPassword">密码错误</div>
				</div>
				<div class="fs14 col3 lh28 mb10">再次输入密码：</div>
				<div class="pr">
					<div :class="isRepeatPassword ? 'prompt_border1' : ''">
						<div class="part2 flex-box">
							<input class="input" id="password" :type="showPwd ? 'text' : 'password'" name="password"
								placeholder="请再次输入密码" v-model="formData.repeat_password" />
							<img @click="showPwd = !showPwd" v-if="showPwd" class="img2 point"
								src="../../assets/static/icon/jxr_login_show.png" alt="" id="eye" />
							<img @click="showPwd = !showPwd" v-else class="img2 point"
								src="../../assets/static/icon/jxr_login_hide.png" alt="" id="eye" />
						</div>
						<div class="fs18 red lh28 prompt_info" v-if="isRepeatPassword">两次密码输入不一致</div>
					</div>
				</div>
				<div class="point" :class="canNext ? 'btn_login_on' : 'btn_login'" @click="canNext ? retPwd() : ''">重置密码
				</div>
			</div>
		</div>
	</div>
	<popup :visible="sucPop" @close="sucPop = false">
		<div class="popup">
			<img @click="sucPop = false" class="close point" src="../../assets/static/icon/jxr_login_close.png"
				alt="" />
			<img class="login_sucess" src="../../assets/static/icon/jxr_login_sucess.png" alt="" />
			<div class="blue fs30 tc fwb mb20 lh40">密码修改成功</div>
			<div class="tc fs24 colc2 kh34">（ {{ closeTime }}S后关闭 ）</div>
		</div>
	</popup>
</template>
<script>
import { useHead } from "@unhead/vue";
import * as com from "@/utils/common.js"; // 导入公共方法
export default {
	name: "index",
	setup() {
		useHead({
			title: "找回密码-小狮优选",
			meta: [
				{ name: "description", content: "This is my page description" },
				{ property: "og:title", content: "My Page Title" },
				{ property: "og:description", content: "This is my page description" },
				{ property: "og:url", content: "https://example.com/my-page" },
				{ property: "og:image", content: "https://example.com/my-image.jpg" },
			],
			link: [{ rel: "canonical", href: "https://example.com/my-page" }],
		});
	},
	mounted() {
		this.$store.commit("setHeader", false);
		this.$store.commit("setRouter", false);
	},
	beforeUnmount() {
		this.$store.commit("setHeader", true);
		this.$store.commit("setRouter", true);
	},
	data() {
		return {
			showPwd: false,
			captcha: "获取验证码",
			totalTime: 60,
			canClick: true, // 节流
			clockTimer: null, // 定时器
			sucPop: false,
			formData: {
				mobile: "",
				code: "",
				password: "",
				repeat_password: "",
				event: 'resetpwd',
			},
			isPhone: false,
			isCode: false,
			isPassword: false,
			isRepeatPassword: false,
			closeTime: 3,//关闭弹窗倒计时
			closeTimer: null,//挂壁弹窗定时器
		};
	},
	computed: {
		canNext() {
			// 下一步
			return (
				this.formData.mobile !== '' &&
				this.formData.code !== '' &&
				this.formData.password !== '' &&
				this.formData.repeat_password !== ''
			);
		},

	},
	methods: {
		// 获取验证码
		handleCaptcha() {
			let that = this;
			if (!that.canClick) return; // 节流 防止频繁访问接口
			if (com.checkPhone(that.formData.mobile)) {
				that.isPhone = false;
				that.canClick = false;
				that.captcha = that.totalTime + "s后重新发送";
				that.clockTimer = window.setInterval(() => {
					that.totalTime--;
					that.captcha = that.totalTime + "s后重新发送";
					if (that.totalTime < 0) {
						window.clearInterval(that.clockTimer);
						that.captcha = "重新发送验证码";
						that.totalTime = 60;
						that.canClick = true;
					}
				}, 1000);
				that.$api.getCode({
					mobile: that.formData.mobile,
					event: 'register'
				});
			} else {
				that.isPhone = true;
			}
		},
		// 重置密码
		retPwd() {
			let that = this;
			// 校验手机号
			if (!com.checkPhone(that.formData.mobile)) {
				that.isPhone = true;
			} else {
				that.isPhone = false;
			}
			// 校验验证码
			if (!com.checkCode(that.formData.code)) {
				that.isCode = true;
			} else {
				that.isCode = false;
			}
			// 校验密码
			if (!com.checkPassword(that.formData.password)) {
				that.isPassword = true;
			} else {
				that.isPassword = false;
			}
			// 再次输入
			if (
				that.formData.password !== that.formData.repeat_password ||
				that.formData.repeat_password == ""
			) {
				that.isRepeatPassword = true;
			} else {
				that.isRepeatPassword = false;
			}
			// 若有错误则无法下一步
			if (that.isPhone || that.isCode || that.isPassword || that.isRepeatPassword) {
				return;
			}
			that.$api.resetPwd({
				...that.formData
			}).then(res => {
				if (res.code == 1) {
					that.sucPop = true;
					that.clockTimer = window.setInterval(() => {
						that.closeTime--;
						if (that.closeTime <= 0) {
							window.clearInterval(that.clockTimer);
							that.closeTime = 3;
							that.sucPop = false;
							that.$router.go(-1);
						}
					}, 1000);
				} else {
					that.$message({
						customClass: 'custom-message',
						message: res.msg,
						type: "error",
						duration: 3000,
					});
				}
			}).catch(err => {
				that.$message({
					customClass: 'custom-message',
					message: err.msg,
					type: "error",
					duration: 3000,
				});
			})
		},
	},
};
</script>
<style lang="less" scoped>
.point {
	cursor: pointer;
}

.bg_f9 {
	background: #f9f9f9;
}

.head_part {
	// width: 1400px;
	margin: 0 auto;
	padding: 40px 0;
}

.login_logo {
	width: 165px;
	display: block;
	object-fit: contain;
}

.line {
	width: 1px;
	height: 45px;
	background: #979797;
}

.col-36 {
	color: #363636;
}

.fw-600 {
	font-weight: 700;
}

.main {
	// width: 1400px;
	margin: 0 auto 30px;
	background: #ffffff;
	padding: 40px 0 40px;
}

.part1 {
	width: 660px;
	margin: 0 auto;
}

.part1 .title {
	font-weight: 700;
	font-size: 30px;
	color: #3d7efe;
	line-height: 42px;
}

.part2 {
	width: 660px;
	height: 45px;
	margin: 0 auto 20px;
	border-radius: 8px;
	overflow: hidden;
	border-radius: 8px;
	border: 1px solid #cccccc;
	padding-left: 16px;
}

.part2 .img1 {
	width: 28px;
	height: 28px;
	display: block;
	object-fit: contain;
	margin-right: 12px;
}

.part2 .img2 {
	width: 24px;
	height: 24px;
	display: block;
	object-fit: contain;
	margin-right: 16px;
}

.part3 {
	margin: 0 auto 16px;
}

.check_img {
	width: 14px;
	height: 14px;
	margin-right: 6px;
	background: rgba(240, 84, 77, 1);
	margin-top: 0;
}

input[type="checkbox"] {
	width: 14px;
	height: 14px;
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	line-height: 15px;
	position: relative;
}

input[type="checkbox"]::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	background: #fff;
	width: 100%;
	height: 100%;
	border: 1px solid #c5cdd6;
}

input[type="checkbox"]:checked::before {
	content: "\2713";
	background-color: #3d7efe;
	position: absolute;
	bottom: 4px;
	left: 0px;
	width: 100%;
	border: 1px solid #3d7efe;
	color: #fff;
	font-size: 10px;
	font-weight: bold;
}

.input {
	padding: 0;
	font-size: 16px;
	height: 100%;
	line-height: 100%;
	flex: 1;
	border: none;
	outline: none;
	width: 100%;
}

.input::placeholder {
	font-size: 14px;
	color: #d3d3d3;
}

.part4 {
	width: 386px;
	margin: 0 auto 44px;
}

.btn_login_on,
.btn_login {
	border: none;
	margin: 30px auto 0;
	font-size: 18px;
	color: #fff;
	// font-weight: 700;
	text-align: center;
	width: 660px;
	height: 45rpx;
	line-height: 45px;
	border-radius: 8px;
	background: #3d7efe;
}

.btn_login {
	background: #bdd3ff;
}

.blue {
	color: #3d7efe;
}

.login_right {
	width: 14px;
	height: 14px;
	display: block;
	object-fit: contain;
}

.code_btn_on,
.code_btn {
	width: 176px;
	height: 45px;
	line-height: 45px;
	background: #3d7efe;
	border-radius: 8px;
	// font-weight: 700;
	font-size: 18px;
	color: #ffffff;
}

.code_btn {
	background: #c2c2c2;
}

.prompt_info {
	position: absolute;
	z-index: 2;
	left: 0;
	top: 70px;
}

.red {
	color: #ed1515;
}

.prompt_border1 {
	width: 660px;
	height: 66px;
	// border: 2px solid #FFD4D4;
	border-radius: 11px;
	margin: 0 auto 30px;
}

.prompt_border1 .part2 {
	// width: 100%;
	// height: 100%;
	border-color: #ed1515;
}

.part33 {
	width: 100%;
}


.popup {
	padding: 20px 26px 65px;
	width: 642px;
	background: #ffffff;
	box-shadow: 0px 4px 17px 0px rgba(0, 0, 0, 0.27);
	border-radius: 26px;
}

.close {
	width: 34px;
	height: 34px;
	display: block;
	object-fit: contain;
	margin-left: auto;
	margin-right: 0;
	margin-bottom: 8px;
}

.login_sucess {
	width: 116px;
	height: 116px;
	display: block;
	object-fit: contain;
	margin: 0 auto 18px;
}

.colc2 {
	color: #c2c2c2;
}
</style>
